export * from './accountResource.service';
import { AccountResourceService } from './accountResource.service';
export * from './actionResource.service';
import { ActionResourceService } from './actionResource.service';
export * from './athleteResource.service';
import { AthleteResourceService } from './athleteResource.service';
export * from './bannerResource.service';
import { BannerResourceService } from './bannerResource.service';
export * from './buyController.service';
import { BuyControllerService } from './buyController.service';
export * from './clientInfoResource.service';
import { ClientInfoResourceService } from './clientInfoResource.service';
export * from './eventResource.service';
import { EventResourceService } from './eventResource.service';
export * from './fileResource.service';
import { FileResourceService } from './fileResource.service';
export * from './newsResource.service';
import { NewsResourceService } from './newsResource.service';
export * from './publicUserResource.service';
import { PublicUserResourceService } from './publicUserResource.service';
export * from './resourceResource.service';
import { ResourceResourceService } from './resourceResource.service';
export * from './roleResource.service';
import { RoleResourceService } from './roleResource.service';
export * from './sportResource.service';
import { SportResourceService } from './sportResource.service';
export * from './transactionResource.service';
import { TransactionResourceService } from './transactionResource.service';
export * from './userJwtController.service';
import { UserJwtControllerService } from './userJwtController.service';
export * from './userProfileResource.service';
import { UserProfileResourceService } from './userProfileResource.service';
export * from './userResource.service';
import { UserResourceService } from './userResource.service';
export * from './userUploadHistoryResource.service';
import { UserUploadHistoryResourceService } from './userUploadHistoryResource.service';
export const APIS = [AccountResourceService, ActionResourceService, AthleteResourceService, BannerResourceService, BuyControllerService, ClientInfoResourceService, EventResourceService, FileResourceService, NewsResourceService, PublicUserResourceService, ResourceResourceService, RoleResourceService, SportResourceService, TransactionResourceService, UserJwtControllerService, UserProfileResourceService, UserResourceService, UserUploadHistoryResourceService];
